<template>
    <v-container>
        <h3 class="grey--text text--darken-2"> Documents </h3>

        <p class="subtitle-1 grey--text text--darken-2">
            Retrouvez ici les différents documents relatifs à votre acquisition
            <ProductsDisplayChips :products="selectedSale.products" />
            sur le programme
            <v-chip color="app-green" class="ma-0 pa-1" small label dark>{{ selectedSale.program.title }}</v-chip>.
        </p>

        <p class="caption grey--text text--darken-2">
            Sélectionnez la catégorie de document que vous souhaitez consulter.
        </p>

        <template v-if="$vuetify.breakpoint.mobile">
            <v-expansion-panels>
                <v-expansion-panel v-for="item of getConfig('documents.allowed_documents_types', [])" :key="item.code" @click="switchTab(item.code)">
                    <v-expansion-panel-header>
                        <span class="mr-1"> {{ item.title }} </span> ({{ getDocumentsByType(item.code).length }})
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <DocumentsView :documents="getDocumentsByType(item.code)"/>

                        <v-card v-if="uploadPlaceholders.length > 0" class="pa-5 mt-5 blue-grey lighten-5" flat>
                            <v-row v-if="uploadPlaceholders.length > 0">
                                <v-col cols="12" lg="3" v-for="placeholder of uploadPlaceholders" :key="placeholder.code">
                                    <v-card v-if="placeholder.document" class="fill-height d-flex flex-column">
                                        <v-card-text class="text-center flex-grow-1">
                                            <v-icon color="red lighten-1"> {{ getDocumentIcon(placeholder.document) }} </v-icon>

                                            <br>

                                            <template v-if="placeholder.document.title">
                                                {{ placeholder.document.title }}
                                            </template>
                                            <template v-else>
                                                <i> [Document sans nom] </i>
                                            </template>
                                        </v-card-text>

                                        <v-divider />

                                        <v-card-actions>
                                            <p class="caption mb-0">
                                                {{ placeholder.document.date | toDate() }}
                                            </p>

                                            <v-spacer />

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn :href="getDocumentUrl(placeholder.document.id, true)" target="_blank" icon small color="primary" v-on="on">
                                                        <v-icon> mdi-download </v-icon>
                                                    </v-btn>
                                                </template>
                                                Télécharger le document
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn :href="getDocumentUrl(placeholder.document.id)" target="_blank" icon small color="primary" v-on="on">
                                                        <v-icon> mdi-open-in-app </v-icon>
                                                    </v-btn>
                                                </template>
                                                Visualiser le document dans un nouvel onglet
                                            </v-tooltip>

                                            <v-tooltip v-if="placeholder.document.validationStatus" top>
                                                <template v-slot:activator="{ on: tooltip }">
                                                    <v-btn icon small color="grey" v-on="{ ...tooltip }">
                                                        <v-icon> mdi-delete </v-icon>
                                                    </v-btn>
                                                </template>
                                                Le document a été validé et ne peut plus être supprimé
                                            </v-tooltip>
                                            <ConfirmationDialog v-else @confirm="deleteDocument(placeholder.document)" :text="`Souhaitez-vous vraiment supprimer le document «${placeholder.document.title}»`">
                                                <template v-slot:activator="{ on: dialog }">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on: tooltip }">
                                                            <v-btn icon small color="error" v-on="{ ...tooltip, ...dialog }">
                                                                <v-icon> mdi-delete </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        Supprimer le document
                                                    </v-tooltip>
                                                </template>
                                            </ConfirmationDialog>
                                        </v-card-actions>
                                    </v-card>
                                    <v-card v-else class="fill-height d-flex flex-column">
                                        <v-card-text class="text-center flex-grow-1">
                                            {{ placeholder.title }}

                                            <DocumentDropZone v-if="!placeholder.document" @update:file="uploadDocument(placeholder, $event)" />
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
        <template v-else>
            <v-tabs v-model="tab" :vertical="$vuetify.breakpoint.mobile">
                <v-tab v-for="item of getConfig('documents.allowed_documents_types', [])" :key="item.code" @click="switchTab(item.code)">
                    {{ item.title }}
                </v-tab>
            </v-tabs>

            <v-card id="docviewer" class="pa-5 mt-5 blue-grey lighten-5" flat>
                <v-row>
                    <v-col cols="12 pb-0">
                        <v-btn @click="downloadDocuments()" small class="float-right" color="primary">
                            TOUT TÉLÉCHARGER
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="tabDocuments.length > 0">
                    <v-col cols="12" lg="3" v-for="document of tabDocuments" :key="document.id">
                        <v-card class="fill-height d-flex flex-column">
                            <v-card-text class="text-center flex-grow-1">
                                <v-icon color="red lighten-1"> {{ getDocumentIcon(document) }} </v-icon>

                                <br>

                                <template v-if="document.title">
                                    {{ document.title }}
                                </template>
                                <template v-else>
                                    <i> [Document sans nom] </i>
                                </template>
                            </v-card-text>

                            <v-divider />

                            <v-card-actions>
                                <p class="caption mb-0">
                                    {{ document.date | toDate() }}
                                </p>

                                <v-spacer />

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn :href="getDocumentUrl(document.id, true)" target="_blank" icon small color="primary" v-on="on">
                                            <v-icon> mdi-download </v-icon>
                                        </v-btn>
                                    </template>
                                    Télécharger le document
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn :href="getDocumentUrl(document.id)" target="_blank" icon small color="primary" v-on="on">
                                            <v-icon> mdi-open-in-app </v-icon>
                                        </v-btn>
                                    </template>
                                    Visualiser le document dans un nouvel onglet
                                </v-tooltip>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row v-else>
                    <v-col>
                        <h2 class="text-center grey--text"> Aucun document </h2>
                    </v-col>
                </v-row>
            </v-card>

            <v-card v-if="uploadPlaceholders.length > 0" class="pa-5 mt-5 blue-grey lighten-5" flat>
                <v-row v-if="uploadPlaceholders.length > 0">
                    <v-col cols="12" lg="3" v-for="placeholder of uploadPlaceholders" :key="placeholder.code">
                         <v-card v-if="placeholder.document" class="fill-height d-flex flex-column">
                            <v-card-text class="text-center flex-grow-1">
                                <v-icon color="red lighten-1"> {{ getDocumentIcon(placeholder.document) }} </v-icon>

                                <br>

                                <template v-if="placeholder.document.title">
                                    {{ placeholder.document.title }}
                                </template>
                                <template v-else>
                                    <i> [Document sans nom] </i>
                                </template>
                            </v-card-text>

                            <v-divider />

                            <v-card-actions>
                                <p class="caption mb-0">
                                    {{ placeholder.document.date | toDate() }}
                                </p>

                                <v-spacer />

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn :href="getDocumentUrl(placeholder.document.id, true)" target="_blank" icon small color="primary" v-on="on">
                                            <v-icon> mdi-download </v-icon>
                                        </v-btn>
                                    </template>
                                    Télécharger le document
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn :href="getDocumentUrl(placeholder.document.id)" target="_blank" icon small color="primary" v-on="on">
                                            <v-icon> mdi-open-in-app </v-icon>
                                        </v-btn>
                                    </template>
                                    Visualiser le document dans un nouvel onglet
                                </v-tooltip>

                                <v-tooltip v-if="placeholder.document.validationStatus" top>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-btn icon small color="grey" v-on="{ ...tooltip }">
                                            <v-icon> mdi-delete </v-icon>
                                        </v-btn>
                                    </template>
                                    Le document a été validé et ne peut plus être supprimé
                                </v-tooltip>
                                <ConfirmationDialog v-else @confirm="deleteDocument(placeholder.document)" :text="`Souhaitez-vous vraiment supprimer le document «${placeholder.document.title}»`">
                                    <template v-slot:activator="{ on: dialog }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon small color="error" v-on="{ ...tooltip, ...dialog }">
                                                    <v-icon> mdi-delete </v-icon>
                                                </v-btn>
                                            </template>
                                            Supprimer le document
                                        </v-tooltip>
                                    </template>
                                </ConfirmationDialog>
                            </v-card-actions>
                        </v-card>
                        <v-card v-else class="fill-height d-flex flex-column">
                            <v-card-text class="text-center flex-grow-1">
                                {{ placeholder.title }}

                                <DocumentDropZone v-if="!placeholder.document" @update:file="uploadDocument(placeholder, $event)" />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </template>
    </v-container>
</template>

<script>
import documentsMixin from '../mixins/documents';
import DocumentsView from '../components/documents/DocumentsView.vue';
import DocumentDropZone from '@/components/widgets/DocumentDropZone.vue';
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue';
import ProductsDisplayChips from '@/components/dashboard/ProductsDisplayChips.vue';

export default {
    name: 'Documents',

    mixins: [documentsMixin],

    components: {
        DocumentsView,
        DocumentDropZone,
        ConfirmationDialog,
        ProductsDisplayChips
    },

    data: () => ({
        tab: 0,
        tabKey: 'sale'
        // tabDocuments: [],
        // uploadPlaceholders: []
    }),

    methods: {
        switchTab(tab) {
            this.tabKey = tab;
            // this.uploadPlaceholders = this.getUploadPlaceholderByTab(this.tabKey);
            // this.tabDocuments = this.getDocumentsByType(this.tabKey).filter((d) => this.uploadPlaceholders.filter((placeholder) => placeholder.code === d.code).length === 0);
            if (document.querySelector('#docviewer')) {
                this.$vuetify.goTo('#docviewer', { duration: 300, easing: 'easeInOutCubic' });
            }
        },

        getUploadPlaceholderByTab(tabKey) {
            const placeholders = [];

            const item = this.getConfig('documents.upload_placeholders').find((i) => i.code === tabKey);

            if (item) {
                let documentPlaceholders = JSON.parse(JSON.stringify(item.documents));
                if (this.tabKey === 'piecesjustificatives') {
                    let i = 0;
                    for (const buyer of this.selectedSale.buyers) {
                        documentPlaceholders.push({
                            code: `CTR_ID_${i}`,
                            title: `Carte d'identité ${buyer.title} ${buyer.name} ${buyer.firstname}`
                        });
                        i++;
                    }
                }

                for (const placeholder of documentPlaceholders) {
                    const document = this.getDocumentsByType(this.tabKey).find((d) => d.code === placeholder.code);
                    if (document) {
                        placeholder.document = document;
                        if (document.author !== 'upload espace client' || document.validationStatus == 1) {
                            continue;
                        }
                    }
                    placeholders.push(placeholder);
                }
            }

            return placeholders;
        },

        getDocumentsByType(type) {
            return this.selectedSale.documents.filter((d) => d.type === type);
        },

        async downloadDocuments() {
            try {
                this.setLoading(true);
                const allowedTypes = this.getConfig('documents.allowed_documents_types', []);
                const docsToDownload = [];
                allowedTypes.forEach((element) => {
                    this.getDocumentsByType(element.code).forEach((doc) => {
                        docsToDownload.push(doc);
                    });
                });
                const documentIds = docsToDownload.map(doc => doc.id);
                const documentObject = docsToDownload.reduce((acc, doc) => {
                    acc[doc.id] = doc.title || '[Document sans nom]';
                    return acc;
                }, {});
                const result = await this.repos.documents.downloadDocuments({ ids: documentIds, docs: documentObject });
                const downloadResult = JSON.parse(decodeURIComponent(result.headers['X-Download-Result']));                
                const url = window.URL.createObjectURL(result.blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Documents - Vente ${this.selectedSale.buyer.name} ref ${this.selectedSale.product.reference}_${this.selectedSale.id}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.setLoading(false);
                if (downloadResult.failed.length > 0) {
                    const failedFileNames = downloadResult.failed.map(doc => doc.fileName).join(', ');
                    this.$notify({
                        title: 'Erreur',
                        text: `Certains documents n'ont pas pu être téléchargés : ${failedFileNames}`,
                        type: 'error'
                    });
                }
            } catch (error) {
                this.setLoading(false);
                console.error('Download failed:', error);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors du téléchargement de vos documents',
                    type: 'error'
                });
            }
        },

        async uploadDocument(placeholder, document) {
            try {
                this.setLoading(true);

                const body = {
                    file: document,
                    title: placeholder.title,
                    code: placeholder.code,
                    author: 'upload espace client',
                    sourceId: this.selectedSale.id,
                    sourceType: 100
                };

                const { success, err } = await this.repos.documents.uploadDocument(body);
                if (success) {
                    this.isOpen = false;
                    this.$notify({
                        title: 'Information',
                        text: 'Le document a bien été téléchargé',
                        type: 'success'
                    });
                    await this.$store.dispatch('application/reload');
                    this.switchTab(this.tabKey);
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors du téléchargement du document',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },

        async deleteDocument(document) {
            try {
                this.setLoading(true);

                const { success, err } = await this.repos.documents.deleteDocument(document.id);
                if (success) {
                    this.isOpen = false;
                    this.$notify({
                        title: 'Information',
                        text: 'Le document a bien été supprimé',
                        type: 'success'
                    });
                    await this.$store.dispatch('application/reload');
                    this.switchTab(this.tabKey);
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de la suppression du document',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        }
    },

    computed: {
        uploadPlaceholders() {
            return this.getUploadPlaceholderByTab(this.tabKey);
            
        },
        tabDocuments() {
            return this.getDocumentsByType(this.tabKey).filter((d) => this.uploadPlaceholders.filter((placeholder) => placeholder.code === d.code).length === 0);
        }
    },

    created() {
        this.$nextTick(() => {
            this.switchTab('sale');
        });
    }
};
</script>

